import { Badge, Box, ButtonBase, /*Divider,*/ styled, useMediaQuery, Theme } from '@mui/material';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import { H6, Small, Tiny } from 'components/Typography';
// import useAuth from 'hooks/useAuth';
import { FC, Fragment, useRef, useState } from 'react';
// import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import PopoverLayout from './PopoverLayout';

// import { useAuthenticator} from '@aws-amplify/ui-react';
import useAuth from 'hooks/useAuth';
// import { useAppDispatch } from 'app/hooks';
// import { Auth } from 'aws-amplify'
// import { GetTeachersInput, GetStudentsInput } from 'API';
// import { useGetTeachersQuery, useGetStudentsQuery } from 'features/api/apiSlice';
// import { Teacher } from 'utils/types'

// styled components
const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  padding: 5,
  marginLeft: 4,
  borderRadius: 30,
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));

const StyledSmall = styled(Small)(({ theme }) => ({
  display: 'block',
  cursor: 'pointer',
  padding: '5px 1rem',
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));

const ProfilePopover: FC = () => {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  // const dispatch = useAppDispatch();
  // const { logout, user } = useAuth();
  const [open, setOpen] = useState(false);
  const upSm = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  // const handleMenuItem = (path: string) => {
  //   navigate(path);
  //   setOpen(false);
  // };

  const {user, isAuthenticated, signOut } = useAuth();
  // const {signOut} = useAuthenticator((context) => [context.signOut]);
  const authStatus = isAuthenticated
  
  if (user) console.log("User :",user)
  const attributes = user? user : {given_name:"unknown", family_name:"user", email:"someone@google.com"}
  if (user) console.log("Profile Popover ",user)
  const name = attributes.given_name + ' ' + attributes.family_name
  const email = attributes.email? attributes.email.length>16?'':attributes.email:''
  if (user) console.log(name)
  var token = ''
  // if (user) {
  //   let session = Auth.currentSession().then((res)=>{
  //     let accessToken = res.getAccessToken()
  //     let jwt = accessToken.getJwtToken()
  //     // dispatch(setToken({token: jwt}));
  //     token = jwt

  //     //You can print them to see the full objects
  //     // console.log(`myAccessToken: ${JSON.stringify(accessToken)}`)
  //     // console.log(`myJwt: ${token}`)
  //   })
  // }

  // const getStudentsInput: GetStudentsInput = {}
  // const { data, error, isLoading } = useGetStudentsQuery({getStudentsInput})
  // console.log("before X :")
  // if (data) console.log("X :", data, error, isLoading)
  // if (data) console.log(data)

  const handleLogout = () => {
    console.log("Signing out")
    signOut();
    navigate('/');
  };

  const doLogin = () => {
    navigate('/login');
  }

  const doTeacher = async () => {
    // const result = await dispatch(fetchTeachers())
  }

  // const getTeachersParams: GetTeachersInput = {email: 'eboylan8@milanacademy.com'}
  // // const { data, error, isLoading } = useGetAllTeachersQuery({GetTeachersInput: {email: 'eboylan8@milanacademy.com'}});
  // const { data, error, isLoading } = useGetAllTeachersQuery(getTeachersParams);
  // console.log("Teach :",data, error, isLoading)

  return (
    <Fragment>
      <StyledButtonBase disableRipple ref={anchorRef} onClick={() => setOpen(true)}>
        <Badge
          overlap="circular"
          variant="dot"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{
            alignItems: 'center',
            '& .MuiBadge-badge': {
              width: 11,
              height: 11,
              right: '4%',
              borderRadius: '50%',
              border: '2px solid #fff',
              backgroundColor: 'success.main',
            },
          }}
        >
          {upSm && (
            <Small mx={1} color="text.secondary">
              Hi,{' '}
              <Small fontWeight="600" display="inline">
                {(authStatus)? name: "Unknown User"}
              </Small>
            </Small>
          )}
          <AppAvatar
            src={/*user?.avatar ||*/ '/static/icons/generic-profile.svg'}
            sx={{ width: 28, height: 28 }}
          />
        </Badge>
      </StyledButtonBase>

      <PopoverLayout
        hiddenViewButton
        maxWidth={230}
        minWidth={200}
        popoverOpen={open}
        anchorRef={anchorRef}
        popoverClose={() => setOpen(false)}
        title={
          <FlexBox alignItems="center" gap={1}>
            <AppAvatar
              src={/*user?.avatar ||*/ '/static/icons/generic-profile.svg'}
              sx={{ width: 35, height: 35 }}
            />

            <Box>
              <H6>{(authStatus)?name : 'Please sign in'}</H6>
              <Tiny display="block" fontWeight={500} color="text.disabled">
                {(authStatus)?email : ''}
              </Tiny>
            </Box>
          </FlexBox>
        }
      >
        <Box pt={1}>
          {/* <StyledSmall onClick={() => handleMenuItem('/dashboard/profile')}>Set Status</StyledSmall>

          <StyledSmall onClick={() => handleMenuItem('/dashboard/profile')}>
            Profile & Account
          </StyledSmall>

          <StyledSmall onClick={() => handleMenuItem('/dashboard/account')}>Settings</StyledSmall>

          <StyledSmall onClick={() => handleMenuItem('/dashboard/team-member')}>
            Manage Team
          </StyledSmall>

          <Divider sx={{ my: 1 }} /> */}

          <StyledSmall
            onClick={() => {
              console.log("Popover click", authStatus)
              authStatus? handleLogout() : doLogin() ;
            }}
          >
            {authStatus? 'Sign Out':'Sign In'}
          </StyledSmall>
          <StyledSmall
            onClick={() => navigate('/dashboard/myinfo')}
          >
            My Info
          </StyledSmall>

        </Box>
      </PopoverLayout>
    </Fragment>
  );
};

export default ProfilePopover;
